var map = {
	"./amadeus/CardholderFeedback.json": 1265,
	"./barlcays/CardholderFeedback.json": 1266,
	"./cb911/CardholderFeedback.json": 1267,
	"./choiceHotels/CardholderFeedback.json": 1268,
	"./globex/CardholderFeedback.json": 1269,
	"./kraken/CardholderFeedback.json": 1270,
	"./lastminute/CardholderFeedback.json": 1271,
	"./monavate/CardholderFeedback.json": 1272,
	"./outpayce/CardholderFeedback.json": 1273,
	"./sofi/CardholderFeedback.json": 1274
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1264;